import { useQuery } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';
import { UseQueryOverrideOptions } from '../common';

export type EHRAppointmentType = {
  id: string;
  name: string;
  color?: string;
  duration?: string;
  hide?: string;
  billable?: string;
  is_telemedicine?: string;
};

type GetEHRAppointmentTypesResponse = {
  appointment_types: EHRAppointmentType[];
  instructions?: Array<{ id: string; name: string; text: string }>;
};

type GetEHRAppointmentTypesParams = {
  ehr_system: string;
  org_uuid: string;
  practice_id?: string;
};

export const useGetEHRAppointmentTypes = (
  params: GetEHRAppointmentTypesParams,
  options: UseQueryOverrideOptions<GetEHRAppointmentTypesResponse> = {}
) => {
  const baseEnabled = !!params.ehr_system && !!params.org_uuid;
  const callerEnabled = options.enabled ?? true;

  return useQuery({
    ...options,
    queryKey: ['ehrAppointmentTypes', params],
    queryFn: () =>
      integrationsApi
        .get<GetEHRAppointmentTypesResponse>('/v2/appointments-types', {
          params,
        })
        .then((res) => res.data),
    enabled: baseEnabled && callerEnabled,
  });
};
